var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-form-page-content"},[(!_vm.showPreloader)?_c('div',{staticClass:"c-form-page-content__content"},[_vm._t("default")],2):_c('div',{staticClass:"c-form-page-content__preloader"},[_c('PreloaderComponent',{attrs:{"width":"125px","height":"125px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }